<template>
  <div class="footer">
    <div class="footer-content content">
      <div class="footer-top flex-sb">
        <div class="flex-fs">
          <div class="footer-top-left">山东省科教人才发展继续教育平台</div>
          <div class="footer-top-middle">
            <div>联系电话:0531-111111</div>
            <div>邮箱: zhongkejianzhu@QQ.com</div>
          </div>
        </div>
        <div class="footer-top-right">
          地址: 山东省济南市市中心六路小纬四路46-1号507
        </div>
      </div>
      <div class="footer-bottom">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
          >鲁ICP备2025180444号-1</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {},
};
</script>

<style lang="less" scoped>
.footer {
  height: 300px;
  font-size: 16px;
  background-image: url(../assets/image/footer/bg.jpg);
  background-size: 100% 100%;
  min-width: 1600px;
  &-top {
    color: #fff;
    height: 228px;
    &-left {
      font-size: 26px;
      font-weight: bold;
      margin-right: 190px;
    }
    &-middle {
      div:nth-child(1) {
        margin-bottom: 15px;
      }
    }
    &-right {
      margin-right: 85px;
      margin-top: -40px;
    }
  }
  &-bottom {
    color: #939393;

    height: 72px;
    line-height: 75px;
    text-align: right;
    a{
      color: #939393;
      text-decoration: none;
    }
  }
}
</style>
